type Breakpoints = string[] & {
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
};

type Theme = {
  borders: {
    card: string;
    carddark: string;
    cardpurple: string;
  };
  borderWidths: [];
  borderStyles: string[];
  radii: number[];
  breakpoints: Breakpoints;
  media: {
    grid: number;
  };
  colors: any;
  fonts: {
    noirPro: string[];
  };
  fontSizes: number[];
  fontWeights: {
    normal: number;
    regular: number;
    medium: number;
    semibold: number;
    bold: number;
    extrabold: number;
  };
  lineHeights: string[];
  letterSpacings: [];
  textDecoration: {
    none: {
      textDecoration: string;
    };
    underline: {
      textDecoration: string;
    };
  };
  space: number[];
  sizes: [];
  shadows: {
    small: string;
  };
  transitions: [];
  zIndices: number[];
};

const theme: Theme = {
  borders: {
    card: `2px solid #EBEBEB`,
    carddark: `2px solid #DEDEDE`,
    cardpurple: `2px solid #3D1952`,
  },
  borderWidths: [],
  borderStyles: ['solid'],
  radii: /* Border radius */ [28],
  breakpoints: ['374px', '678px', '960px', '1278px'] as BreakpointsProp,
  media: {
    grid: 1280,
  },
  colors: /* Colors, Background-colors, */ {
    blacks: ['#2B2C32', '#000000'],
    blue: '#007A85',
    blues: ['#007A85', '#00828E'],
    carbon: '#2B2C32',
    grey: '#7C7F83',
    greys: [
      '#F7F7F7',
      '#EBEBEB',
      '#7C7F83',
      '#2b2c32',
      '#232429',
      '#6d6d6d',
      '#d8d8d8',
      '#FCFCFC'
    ],
    red: '#E1251B',
    reds: ['#E1251B', '#c1211b'],
    whites: ['#FFFFFF', 'rgba(255, 255, 255, 0.95)'],
    teal: '#007A85',
    white: '#FFFFFF',
    black: '#2B2C32',
    velvet: '#3D1952',
    stone: '#F7F7F7',
    'light-peach': '#FAECEC',
    'dark-peach': '#F3736D',
    'light-border-grey': '#E8E9EB',
    'border-grey': '#D8D8D8',
    'secondary-teal': '#00646d',
    'primary-text': '#2B2C32',
    'secondary-text': '#686868',
    'secondary-grey': '#e8e9eb',
    'light-grey': '#EBEBEB',
    'pale-grey': '#f7f7f7',
  },
  fonts: {
    noirPro: ['Noir Pro', 'Arial', 'Helvetica', 'sans-serif'],
  },
  fontSizes: [14, 15, 16, 18, 20, 24, 26, 30, 40, 50, 60, 90, 150],
  fontWeights: {
    normal: 400,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  lineHeights: [
    '24px',
    '28px',
    '30px',
    '32px',
    '34px',
    '36px',
    '40px',
    '44px',
    '50px',
    '56px',
    '60px',
    '70px',
    '100px',
    '150px',
  ],
  letterSpacings: [],
  textDecoration: {
    none: {
      textDecoration: 'none',
    },
    underline: {
      textDecoration: 'underline',
    },
  },
  space: /* Margin, Padding, Grid Spacing */ [
    0, 4, 8, 16, 32, 64, 128, 256, 512,
  ],
  sizes: /* Width, Height, +min, +max (min - 1) */ [],
  shadows: /* Box-Shadow, Text-Shadow */ {
    small: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)',
  },
  transitions: [],
  zIndices: [0, 1, 2, 3, 6, 12, 24, 48, 96],
};
theme.breakpoints.sm = theme.breakpoints[0];
theme.breakpoints.md = theme.breakpoints[1];
theme.breakpoints.lg = theme.breakpoints[2];
theme.breakpoints.xl = theme.breakpoints[3];

// 320, 375, 508, 550, 665, 700, 768, 916, 1279, 1399, 1440

export default theme;

type BreakpointsProp = Array<string> & {
  sm?: string,
  md?: string,
  lg?: string,
  xl?: string,
}
